import { render } from "./FaqsPage.vue?vue&type=template&id=b66475a6&scoped=true"
import script from "./FaqsPage.vue?vue&type=script&lang=js"
export * from "./FaqsPage.vue?vue&type=script&lang=js"

import "./FaqsPage.vue?vue&type=style&index=0&id=b66475a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66475a6"]])

export default __exports__